// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3IYuv","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1NZea"};